











































import Vue from 'vue';

export default Vue.extend({
  name: 'GAuthSiteFooter',
  computed: {
    isAuthPage(): boolean {
      const path = this.$route.path;
      const signin = '/auth/signin';
      const signup = '/auth/signup';
      const reset = '/auth/reset';
      const array = [signin, signup, reset];
      return array.some((item) => item.includes(path));
    },
  },
});
